/* bs-collection-guide — animación del <details> al expandir/cerrar.
   Los <details> nativos no animan height. Interceptamos click del summary,
   prevenimos el toggle default, y animamos manualmente height + opacity.
*/
(function () {
  'use strict';

  const ANIM_MS = 300;

  document.addEventListener('click', (e) => {
    const summary = e.target.closest('summary.bs-collection-guide__toggle');
    if (!summary) return;
    e.preventDefault();

    const details = summary.parentElement;
    const content = details.querySelector('.bs-collection-guide__full');
    if (!content) return;

    if (details._bsAnimating) return;
    details._bsAnimating = true;

    const isOpen = details.hasAttribute('open');

    if (isOpen) {
      // Closing: from current height to 0
      const startHeight = content.scrollHeight;
      content.style.height = startHeight + 'px';
      content.style.opacity = '1';
      // Force reflow para que el browser aplique el height inicial
      content.offsetHeight;
      content.style.height = '0px';
      content.style.opacity = '0';

      setTimeout(() => {
        details.removeAttribute('open');
        content.style.height = '';
        content.style.opacity = '';
        details._bsAnimating = false;
      }, ANIM_MS);
    } else {
      // Opening: set open, height from 0 to scrollHeight
      details.setAttribute('open', '');
      content.style.height = '0px';
      content.style.opacity = '0';
      content.offsetHeight;
      const targetHeight = content.scrollHeight;
      content.style.height = targetHeight + 'px';
      content.style.opacity = '1';

      setTimeout(() => {
        content.style.height = '';
        content.style.opacity = '';
        details._bsAnimating = false;
      }, ANIM_MS);
    }
  });
})();
